export class FocusManager {
    static focused = true;
    static title = null;
    static titleAssigned = false;
    static eventListeners = [];
    static EVENTS = {
        FOCUS: "focus",
        BLUR: "blur"
    };

    static addEventListener(callback, context) {
        FocusManager.eventListeners.push({ callback, context });
    }

    static removeEventListener(callback, context) {
        for (let i = 0; i < FocusManager.eventListeners.length; i++) {
            if (FocusManager.eventListeners[i].callback === callback && FocusManager.eventListeners[i].context === context) {
                // Remove single entry from array, and return immediately
                // as continuing iteration is unsafe, as the underlying array
                // has been modified
                FocusManager.eventListeners.splice(i, 1);
                return;
            }
        }
    }

    static init() {
        $(window).focus(() => {
            // Store focus state in convenient location.
            FocusManager.focus();
        });

        $(window).blur(() => {
            // Store focus state in convenient location.
            FocusManager.blur();
        });

        $(window).on("pointerdown.titleAssignment keydown.titleAssignment", () => {
            $(window).off(".titleAssignment");
            FocusManager.clearTitle();
        });
    }

    static focus() {
        FocusManager.focused = true;

        FocusManager.clearTitle();

        FocusManager._notifyEventListeners(FocusManager.EVENTS.FOCUS);
    }

    static blur() {
        FocusManager.focused = false;

        FocusManager._notifyEventListeners(FocusManager.EVENTS.BLUR);
    }

    static isFocused() {
        return FocusManager.focused;
    }

    static setTitle(title) {
        FocusManager.title = title;
        if (FocusManager.titleAssigned) {
            document.title = title;
        }
    }

    static showMessageInTitle(msg) {
        document.title = `TankTrouble - ${msg}`;
    }

    static clearTitle() {
        FocusManager.titleAssigned = true;
        document.title = FocusManager.title;
    }

    static _notifyEventListeners(evt, data) {
        for (let i = 0; i < FocusManager.eventListeners.length; i++) {
            FocusManager.eventListeners[i].callback(FocusManager.eventListeners[i].context, evt, data);
        }
    }
}
